import React, {Component, PropTypes} from 'react'
import {Row, Col, OverlayTrigger, Tooltip} from 'react-bootstrap'
import extract from '../../core/extract'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import i18n from '../i18n'
import style from './CompanyCard.less'

class CompanyCard extends Component {
    static propTypes = {
        company: PropTypes.object.isRequired
    }

    render() {
        const {company, ...others} = this.props

        const tooltip = (text) => (
            <Tooltip>{text}</Tooltip>
        )

        const header = (
            <div>
                <h5>{extract(i18n.companyTypeEnum, company.companyType)}</h5>
                {(company.billingType == 'PremiumAccount' || company.billingType == 'StandardAccount') && (
                    <div className={style.billingType}>
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(extract(i18n.billingTypeEnum, company.billingType))}>
                            <div className={style[company.billingType]} alt={company.billingType} title={company.billingType}>{company.billingType[0]}</div>
                        </OverlayTrigger>
                    </div>
                )}
            </div>
        )

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                    {!company.isActive && (
                        <div className={style.status}>
                            <Icon icon='closed' size='sm' />
                        </div>
                    )}
                    <div className={style.label}>
                        <h5>> {company.label}</h5>
                    </div>
                </Card>
            </div>
        )
    }
}

export default CompanyCard


// WEBPACK FOOTER //
// ./lib/company/components/CompanyCard.js